import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment SaleItemGroupFragment
 * @since 1.0.0
 */
export const SaleItemGroupFragment = gql `
  fragment SaleItemGroupFragment on SaleItemGroup {
    id
    entity
    title
    infos
    order
    display
    useInQueryBuilder
    excludeFromInternalDeal
    hasUniqueOptionRestriction
    mustHaveOptionSelected
    createdAt
    updatedAt

    image {
      ...MediaFragment
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }

    parent {
      id
      title
    }
  }

  ${LanguageFragment}
  ${MediaFragment}
`;
